import strings from 'owa-strings/owa-mail-strings';
export default function getFriendlySubject(subject) {
    subject = subject || '';
    if (subject.trim() == '') {
        subject = strings.noSubject;
    }
    return subject;
}
//# sourceMappingURL=getFriendlySubject.js.map